/*
各种浏览器的 navigator.userAgent信息
Google:   mozilla/5.0 (windows nt 6.1; win64; x64) applewebkit/537.36 (khtml, like gecko) chrome/71.0.3578.98 safari/537.36
360J:     mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/55.0.2883.87 safari/537.36
360A:     mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/63.0.3239.132 Safari/537.36 QIHU 360SE
UC:       mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/55.0.2883.87 ubroswer/6.2.4094.1 safari/537.36
SG:       mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/49.0.2623.221 safari/537.36 se 2.x metasr 1.0
QQ:       mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/63.0.3239.26 safari/537.36 core/1.63.5682.400 qqbroswer/10.1.1880.400
2345:     mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/56.0.2924.90 safari/537.36 2345explorer/9.6.0.18627
遨游:     mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/61.0.3163.79 safari/537.36 maxthon/5.2.7.2000
baidu:    mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/47.0.2526.106 bidubroswer/8.7 safari/537.36
猎豹：    mozilla/5.0 (windows nt 6.1; wow64) applewebkit/537.36 (khtml, like gecko) chrome/57.0.2987.98 safari/537.36 lbbroswer
Edge:     mozilla/5.0 (windows nt 10.0; win64; x64) applewebkit/537.36 (khtml, like gecko) chrome/64.0.3282.140 safari/537.36 edge/17.17134

WeChat:   mozilla/5.0 (iphone; cpu iphone os 9_3_2 like mac os x) applewebkit/601.1.46 (khtml, like gecko) mobile/13f69 micromessenger/6.7.4(0x1607042c) nettype/wifi language/zh_cn
QQEN:     mozilla/5.0 (iphone; cpu iphone os 9_3_2 like mac os x) applewebkit/601.1.46 (khtml, like gecko) mobile/13f69 qq/5.2.0.1 nettype/wifi mem/32
QQ:       mozilla/5.0 (iphone; cpu iphone os 9_3_2 like mac os x) applewebkit/601.1.46 (khtml, like gecko) mobile/13f69 qq/7.8.1.401 v1_iph_sq_7.8.1_1_app_a pixel/640 core/uiwebview device/apple(iphone x) nettype/wifi qbwebviewtype/1
Safari:   mozilla/5.0 (macintosh; intel mac os x 10_13_6) applewebkit/605.1.15 (khtml, like gecko) version/12.0.3 safari/605.1.15
Firefox:  mozilla/5.0 (windows nt 6.1; win64; x64; rv:65.0) gecko/20100101 firefox/65.0
IE:       mozilla/5.0 (windows nt 6.1; wow64; trident/7.0; slcc2; .net clr 2.0.50727; .net clr 3.5.30729; .net clr 3.0.30729; .net4.0c; .net4.0e; infopath.3; rv:11.0) like gecko
*/
! function(win) {
  "use strict";
  var Browser = function() {
    //浏览器内核信息
    this.user = navigator.userAgent;
    //终端系统
    this.platform = navigator.platform;
    //获取浏览器信息
    this.browser = this.getBrowser();
    //系统版本号
    this.system = {
      name: this.systemName(),
      version: this.systemVersion()
    }
  };
  Browser.prototype.systemName = function() { //判断所处操作系统
    var userAgent = this.user.toLowerCase();
    //苹果系统
    var isMac = (this.platform == "Mac68K") || (this.platform == "MacPPC") || (this.platform == "Macintosh") || (this
      .platform == "MacIntel");
    if (isMac) {
      return "Mac OS X";
    }
    var isPhone = this.platform == "iPhone";
    if (isPhone) {
      return "iPhone";
    }
    var isPad = this.platform == "iPad";
    if (isPad) {
      return "iPad";
    }
    var isPod = this.platform == "iPod";
    if (isPod) {
      return "iPod";
    }
    //Windows系统
    var isWin = (this.platform == "Win32") || (this.platform == "Win64") || (this.platform == "wow64");
    //Unix系统
    var isUnix = (this.platform == "X11") && !isWin && !isMac && !isPhone && !isPad && !isPod;
    if (isUnix) {
      return "Unix";
    }
    //Liunx内核
    var isLinux = (String(this.platform).indexOf("Linux") > -1);
    if (isLinux) {
      //Android系统
      if (userAgent.match(/android/i) == "android") {
        return "Android"
      };
      //Linux系统
      return "Linux"
    }
    //Windows系统
    if (isWin) {
      if (userAgent.indexOf("windows nt 5.0") > -1 || userAgent.indexOf("windows 2000") > -1) {
        return "Win2000"
      };
      if (userAgent.indexOf("windows nt 5.1") > -1 || userAgent.indexOf("windows XP") > -1) {
        return "WinXP"
      };
      if (userAgent.indexOf("windows nt 5.2") > -1 || userAgent.indexOf("windows 2003") > -1) {
        return "Win2003"
      };
      if (userAgent.indexOf("windows nt 6.0") > -1 || userAgent.indexOf("windows Vista") > -1) {
        return "WinVista"
      };
      if (userAgent.indexOf("windows nt 6.1") > -1 || userAgent.indexOf("windows 7") > -1) {
        return "Win7"
      };
      if (userAgent.indexOf("windows nt 6.2") > -1 || userAgent.indexOf("windows 8") > -1) {
        return "Win8"
      };
      if (userAgent.indexOf("windows nt 10.0") > -1 || userAgent.indexOf("windows 10") > -1) {
        return "Win10"
      };
    }
    return "Other";
  };
  Browser.prototype.systemVersion = function() { //判断当前操作系统的版本号
    var userAgent = this.user.toLowerCase();
    if (userAgent.indexOf("mac os x") > -1) {
      return userAgent.split("os ")[1].split("applewebkit")[0].replace(/[^0-9|_]/ig, "").replace(/[_]/ig, ".");
    }
    var is64 = userAgent.indexOf("win64") > -1 || userAgent.indexOf("wow64") > -1;
    if (is64) {
      return "64";
    } else {
      return "32";
    }
  };
  /**
   * 是否是移动浏览器
   *  /Android|webOS|iPhone|iPad|iPod|BlackBerry|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i
   * @returns {Boolean}
   */
  Browser.prototype.isMobile = function() {
    var ua = this.user.toLowerCase();
    return ua.match(/(iPhone|iPod|Android|MQQbroswer|Windows Phone)/i) != null;
  };
  /**
   * 是否是微信浏览器
   *
   * @returns {Boolean}
   */
  Browser.prototype.isWeixin = function() {
    var ua = this.user.toLowerCase();
    return ua.match(/MicroMessenger/i) == "micromessenger";
  };
  /**
   * 获取浏览器名
   *
   */
  Browser.prototype.getBrowser = function() { //
    var matchBS;
    var ua = this.user.toLowerCase();
    var rMsie = /(msie\s|trident)\/([\w.]+)/; //IE浏览器 Trident内核最慢
    var rPresto = /(presto|blink)\/([\w.]+)/; //Opera
    var safari = /(safari)\/([\w.]+)/; //苹果
    var rGecko = /(firefox)\/([\w.]+)/; //火狐
    var rEdge = /(edge)\/([\w.]+)/; //Edge
    var rNewOpera = /(opr)\/(.+)/; //新Opera 基于谷歌
    var rMetasr = /(metasr)([\s])/; //搜狗
    var rKS = /(lbbroswer)\/([\w.]+)/; //猎豹
    var rChrome = /(chrome)\/([\w.]+)/; //谷歌
    var rFirefox = /(firefox)\/([\w.]+)/; //火狐
    var rMaxthon = /(maxthon)\/([\w.]+)/; //遨游
    var rQQ = /(qqbrowser|qq)\/([\w.]+)/; //QQ
    var r2345 = /(2345explorer)\/([\w.]+)/; //2345
    var rOpera = /(opera).+version\/([\w.]+)/; //旧Opera
    var rUC = /(ubrowser|ucbrowser)\/([\w.]+)/; //UC
    var rSafari = /version\/([\w.]+).*(safari)/; //苹果Safari浏览器
    var rWeChat = /(micromessenger)\/([\w.]+)/; //微信浏览器

    var mBroswer = {
      name: "chrome",
      version: 0,
      webkit: {
        name: "chrome",
        version: rChrome.exec(ua) ? rChrome.exec(ua)[2] : "未知内核版本号"
      }
    };
    //搜狗浏览器
    matchBS = rMetasr.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent))) {
      mBroswer.version = ua.split(matchBS[0])[1];
      mBroswer.name = "搜狗";
      return mBroswer;
    }
    //遨游
    matchBS = rMaxthon.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent))) {
      //遨游在Mac OS X上用的safari的内核
      if (this.systemName() == "Mac OS X") {
        //Safari（苹果）浏览器
        mBroswer.webkit.version = safari.exec(ua)[2] || 0;
        mBroswer.webkit.name = "safari";
      }
      mBroswer.version = matchBS[2] || 0;
      mBroswer.name = "遨游";
      return mBroswer;
    }
    //2345浏览器
    matchBS = r2345.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent))) {
      mBroswer.name = "2345";
      mBroswer.version = matchBS[2] || 0;
      return mBroswer;
    }
    //猎豹浏览器
    matchBS = rKS.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent))) {
      mBroswer.version = matchBS[2] || 0;
      mBroswer.name = "猎豹";
      return mBroswer;
    }
    //QQ浏览器
    matchBS = rQQ.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent))) {
      mBroswer.version = matchBS[2] || 0;
      mBroswer.name = "QQ";
      return mBroswer;
    }
    //UC浏览器
    matchBS = rUC.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent))) {
      mBroswer.version = matchBS[2] || 0;
      mBroswer.name = "UC";
      return mBroswer;
    }
    //New Opera浏览器
    matchBS = rNewOpera.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent))) {
      mBroswer.version = matchBS[2] || 0;
      mBroswer.name = "New Opera";
      return mBroswer;
    }
    //谷歌浏览器
    matchBS = rChrome.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent))) {
      //360浏览器
      var is360 = _mime("type", "application/vnd.chromium.remoting-viewer");

      function _mime(option, value) {
        var mimeTypes = navigator.mimeTypes;
        for (var mt in mimeTypes) {
          if (mimeTypes[mt][option] == value) {
            return true;
          }
        }
        return false;
      }
      if (is360) {
        //是否为360极速浏览器 navigator.connection只有360安全浏览器有
        var is360se = !navigator.connection;
        mBroswer.name = is360se ? "360SE" : "360EE";
      }
      mBroswer.version = matchBS[2] || 0;
      return mBroswer;
    }
    //Safari（苹果）浏览器
    matchBS = rSafari.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent)) && (!(window.chrome)) && (!(window.opera))) {
      mBroswer.webkit.version = safari.exec(ua)[2] || 0;
      mBroswer.version = matchBS[1] || 0;
      mBroswer.name = "Safari";
      mBroswer.webkit.name = "safari";
      return mBroswer;
    }
    //火狐浏览器
    matchBS = rFirefox.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent))) {
      mBroswer.webkit.version = rGecko.exec(ua)[2] || 0
      mBroswer.version = matchBS[2] || 0;
      mBroswer.name = "火狐";
      mBroswer.webkit.name = "firefox";
      return mBroswer;
    }
    //Old Oper浏览器
    matchBS = rOpera.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent))) {
      mBroswer.webkit.version = rPresto.exec(ua)[2] || 0
      mBroswer.version = matchBS[2] || 0;
      mBroswer.webkit.name = "Presto";
      mBroswer.name = "Oper";
      return mBroswer;
    }
    //IE浏览器
    var isIE = ua.indexOf("compatible") > -1 && ua.indexOf("msie") > -1; //判断是否IE<11浏览器
    var isIE11 = ua.indexOf('trident') > -1 && ua.indexOf("rv:11.0") > -1;
    var isEdge = ua.indexOf("edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    mBroswer.webkit.version = rMsie.exec(ua)[2] || 0;
    mBroswer.webkit.name = rMsie.exec(ua)[1];
    mBroswer.name = "IE";
    if (isIE) {
      new RegExp("msie (\\d+\\.\\d+);").test(ua);
      var fIEVersion = parseFloat(RegExp["$1"]);
      mBroswer.version = fIEVersion;
      if (fIEVersion < 7) {
        mBroswer.version = 6;
      }
      return mBroswer;
    } else if (isIE11) { //IE11
      mBroswer.version = 11;
      return mBroswer;
    } else if (isEdge) { //edge
      mBroswer.version = rEdge.exec(ua)[2] || 0;
      mBroswer.name = "EDGE";
      return mBroswer;
    }
    //可能是移动端
    matchBS = rWeChat.exec(ua);
    if ((matchBS != null) && (!(window.attachEvent))) {
      mBroswer.version = matchBS[2] || 0;
      mBroswer.webkit.version = matchBS[2] || 0;
      mBroswer.name = "微信";
      mBroswer.webkit.name = "micromessenger";
      return mBroswer;
    }
    return mBroswer;
  };
  /**************************************************************************************************************************************************************************************************************/
  //IO
  var IO = function() {

  };
  IO.prototype.base64ToBlob = function(dataurl) {
    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], {
      type: mime
    });
  };
  /**
   * 将blob转换为base64
   */
  IO.prototype.blobToBase64 = function(blob) {
    return new Promise((resolve, reject) => {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(blob);
      fileReader.onload = function() {
        resolve(this.result);
      }
    });
  };
  /**
   * 将blob转换为file
   */
  IO.prototype.blobToFile = function(theBlob, fileName) {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  };
  // 将base64转换为file
  IO.prototype.base64ToFile = function(base64Data, imageName) {
    var blob = this.base64ToBlob(base64Data);
    return this.blobToFile(blob, imageName);
  };
  /**
   * 文件转成blob路径
   */
  IO.prototype.fileToBlob = function(file) {
    if (window.createObjectURL != undefined) { // basic
      return window.createObjectURL(file);
    }
    if (window.URL.createObjectURL != undefined) { // mozilla(firefox)
      return window.URL.createObjectURL(file);
    }
    if (window.webkitURL != undefined) { // webkit or chrome
      return window.webkitURL.createObjectURL(file);
    }
  };
  /**
   * 网络图片转Blob
   */
  IO.prototype.urlToBlob = function(path) {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open('get', path, true);
      xhr.responseType = 'blob';
      // xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr.onload = function() {
        if (this.status == 200) {
          resolve(this.response);
        } else {
          reject(false);
        }
      };
      xhr.send();
    });
  };
  /**
   * 网络图片转Base64
   */
  IO.prototype.urlToBase64 = function(path) {
    return new Promise((resolve, reject) => {
      var xhr = new XMLHttpRequest();
      xhr.open('get', path, true);
      xhr.responseType = 'blob';
      // xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
      xhr.onload = function() {
        if (this.status == 200) {
          var fileReader = new FileReader();
          fileReader.readAsDataURL(this.response);
          fileReader.onload = function() {
            resolve(this.result);
          }
        } else {
          reject(false);
        }
      };
      xhr.send();
    });
  };
  win.support = {
    v: "1.0.0",
    browser: new Browser(),
    io: new IO()
  }
}(window);



// WEBPACK FOOTER //
// ./src/common/support.js